module.exports = __webpack_public_path__ + "f2661af2fd2b1f87bcf56f85bad695c6.png";